import React from 'react'
import LoginController from '/src/ui/domain/login/login_controller'

export default function Login() {
  return (
    <LoginController />
  )
}
